import axios from '../utils/axios';

export default function deleteRecruiterProfile(adminId, recruiterId, data) {
    return axios.post(`/admin/${adminId}/recruiter/${recruiterId}/delete`, data)
        .then(response => response)
        .catch(error => error);
}
